import { render, staticRenderFns } from "./PutUpRecommendations.vue?vue&type=template&id=6f02fa30&"
import script from "./PutUpRecommendations.vue?vue&type=script&lang=ts&"
export * from "./PutUpRecommendations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports